import { customFetch } from "../../api/fetchAApi"
import { ReleaseType, ResourceType } from "../interfaces/notification-data.interface"



export const fetchChangelog = (type: ResourceType, version: string, releaseType: ReleaseType, hwVersion: string) => {
    return customFetch(`/api/setting/changeLog?type=${type}&version=${version}&releaseType=${releaseType}&hwVersion=${hwVersion}`)
}

export const fetchNotificationData = async (isCheckSoftwareUpdate?: boolean) => {
    return customFetch(`/api/notification/notificationData?isCheckSoftwareUpdate=${isCheckSoftwareUpdate ?? false}`)
}

export const fetchRollbackListOption = async () => {
    return customFetch('/api/notification/rollbackListOption')
}

export const fetchInstallationStatus = async () => {
    return fetch('/api/about/getInstallationStatus')
}

export const fetchLatestInstallationState = async () => {
    return fetch('/api/about/getLatestInstallationState')
}